import { defineNuxtPlugin } from '#app/nuxt'
import { LazyContextMenuCell, LazyGeneratesWidget, LazyHeaderContent, LazyImageLayout, LazyJivoButton, LazyLoadingDots, LazyNewTextarea, LazyProjectDivider, LazySnippetLink, LazyTelegramPopup, LazyTitleLayout, LazyVAccordion, LazyVBadge, LazyVButton, LazyVDivider, LazyVFooter, LazyVHeader, LazyVInput, LazyVLabel, LazyVLoader, LazyVPlaceholder, LazyVTag, LazyVTextarea, LazyAuthHeader, LazyAuthModal, LazyAuthLoginForm, LazyAuthPasswordInput, LazyAuthRegisterForm, LazyAuthVAuth, LazyAuthVRecoverPassword, LazyAuthVkAuthButton, LazyAuthYandexAuthButton, LazyCardsPageSideCard, LazyCardsProjectCard, LazyCardsReviewCard, LazyCardsSubjectTopicCard, LazyCardsTariffCard, LazyCardsTopicCard, LazyCommonCardCommon, LazyCommonFilePicture, LazyCommonOptimizedImage, LazyCommonSkeletonLoader, LazyCommonTinkoffBadge, LazyCommonVChip, LazyCommonVCollapse, LazyCommonVDialog, LazyCommonVDrawer, LazyCommonVDropdown, LazyCommonVLoader, LazyCommonVModal, LazyCommonVSpinner, LazyCommonVSwitch, LazyCommonVTabs, LazyCommonFormCheckboxListField, LazyCommonFormMaskedInput, LazyCommonFormVButton, LazyCommonFormVCheckbox, LazyCommonFormVInput, LazyCommonFormVRadio, LazyCommonFormVSelect, LazyCommonFormVTextarea, LazyPagesIndexLastProjects, LazyPagesIndexVAdvantages, LazyPagesIndexVCreate, LazyPagesIndexVCreateWithSuggests, LazyPagesIndexVFaq, LazyPagesIndexVFeedback, LazyPagesIndexVPrice, LazyPagesIndexVPromo, LazyPagesProjectsActionBlock, LazyPagesProjectsChangeStructureButton, LazyPagesProjectsContentListPage, LazyPagesProjectsContentPage, LazyPagesProjectsEditorContentPage, LazyPagesProjectsFloatingRateCard, LazyPagesProjectsNewProjectContent, LazyPagesProjectsProject, LazyPagesProjectsProjectAdminPanel, LazyPagesProjectsProjectChapter, LazyPagesProjectsProjectContent, LazyPagesProjectsProjectMainDownload, LazyPagesProjectsProjectMainTop, LazyPagesProjectsProjectPageSide, LazyPagesProjectsPromocodeInput, LazyPagesProjectsSimilarProjects, LazyPagesProjectsTItlePage, LazyPagesProjectsActionBlockTimer, LazyPagesProjectsActionBlockCopyActionBlock, LazyPagesProjectsActionBlockFixedActionBlock, LazyPagesProjectsActionBlockPaymentActionBlock, LazyPagesProjectsActionBlockPaymentPendingBlock, LazyPagesProjectsActionBlockPromocodeModalButton, LazyPagesProjectsDownloadButtonsDownloadDocument, LazyPagesProjectsDownloadButtonsDownloadPresentation, LazyPagesProjectsEditorContentEditor, LazyPagesProjectsEditorRu, LazyPagesProjectsPaymentCopyButton, LazyPagesProjectsPaymentNewPaymentButton, LazyPagesProjectsPaymentButton, LazyPagesProjectsPaymentDropdownButton, LazyPagesProjectsPaymentErrorModal, LazyPromoFixedRefundBanner, LazyPromoRefundBanner, LazyPromoRefundDetailsPopup, LazyPromoBlackFridayBadge, LazyPromoBlackFridayBanner, LazyPromoBlackFridayTimer, LazyRatingRateModal, LazyRatingReviewRating, LazyRatingSorryModal, LazyRatingStarRatingIconStar, LazyRatingStarRatingOtzovikModal, LazyRatingStarRating, LazyTopicsSubjectTopics, LazyTopicsVTopics, LazyUserAccountModal, LazyUserDeleteRequest } from '#components'
const lazyGlobalComponents = [
  ["ContextMenuCell", LazyContextMenuCell],
["GeneratesWidget", LazyGeneratesWidget],
["HeaderContent", LazyHeaderContent],
["ImageLayout", LazyImageLayout],
["JivoButton", LazyJivoButton],
["LoadingDots", LazyLoadingDots],
["NewTextarea", LazyNewTextarea],
["ProjectDivider", LazyProjectDivider],
["SnippetLink", LazySnippetLink],
["TelegramPopup", LazyTelegramPopup],
["TitleLayout", LazyTitleLayout],
["VAccordion", LazyVAccordion],
["VBadge", LazyVBadge],
["VButton", LazyVButton],
["VDivider", LazyVDivider],
["VFooter", LazyVFooter],
["VHeader", LazyVHeader],
["VInput", LazyVInput],
["VLabel", LazyVLabel],
["VLoader", LazyVLoader],
["VPlaceholder", LazyVPlaceholder],
["VTag", LazyVTag],
["VTextarea", LazyVTextarea],
["AuthHeader", LazyAuthHeader],
["AuthModal", LazyAuthModal],
["AuthLoginForm", LazyAuthLoginForm],
["AuthPasswordInput", LazyAuthPasswordInput],
["AuthRegisterForm", LazyAuthRegisterForm],
["AuthVAuth", LazyAuthVAuth],
["AuthVRecoverPassword", LazyAuthVRecoverPassword],
["AuthVkAuthButton", LazyAuthVkAuthButton],
["AuthYandexAuthButton", LazyAuthYandexAuthButton],
["CardsPageSideCard", LazyCardsPageSideCard],
["CardsProjectCard", LazyCardsProjectCard],
["CardsReviewCard", LazyCardsReviewCard],
["CardsSubjectTopicCard", LazyCardsSubjectTopicCard],
["CardsTariffCard", LazyCardsTariffCard],
["CardsTopicCard", LazyCardsTopicCard],
["CommonCardCommon", LazyCommonCardCommon],
["CommonFilePicture", LazyCommonFilePicture],
["CommonOptimizedImage", LazyCommonOptimizedImage],
["CommonSkeletonLoader", LazyCommonSkeletonLoader],
["CommonTinkoffBadge", LazyCommonTinkoffBadge],
["CommonVChip", LazyCommonVChip],
["CommonVCollapse", LazyCommonVCollapse],
["CommonVDialog", LazyCommonVDialog],
["CommonVDrawer", LazyCommonVDrawer],
["CommonVDropdown", LazyCommonVDropdown],
["CommonVLoader", LazyCommonVLoader],
["CommonVModal", LazyCommonVModal],
["CommonVSpinner", LazyCommonVSpinner],
["CommonVSwitch", LazyCommonVSwitch],
["CommonVTabs", LazyCommonVTabs],
["CommonFormCheckboxListField", LazyCommonFormCheckboxListField],
["CommonFormMaskedInput", LazyCommonFormMaskedInput],
["CommonFormVButton", LazyCommonFormVButton],
["CommonFormVCheckbox", LazyCommonFormVCheckbox],
["CommonFormVInput", LazyCommonFormVInput],
["CommonFormVRadio", LazyCommonFormVRadio],
["CommonFormVSelect", LazyCommonFormVSelect],
["CommonFormVTextarea", LazyCommonFormVTextarea],
["PagesIndexLastProjects", LazyPagesIndexLastProjects],
["PagesIndexVAdvantages", LazyPagesIndexVAdvantages],
["PagesIndexVCreate", LazyPagesIndexVCreate],
["PagesIndexVCreateWithSuggests", LazyPagesIndexVCreateWithSuggests],
["PagesIndexVFaq", LazyPagesIndexVFaq],
["PagesIndexVFeedback", LazyPagesIndexVFeedback],
["PagesIndexVPrice", LazyPagesIndexVPrice],
["PagesIndexVPromo", LazyPagesIndexVPromo],
["PagesProjectsActionBlock", LazyPagesProjectsActionBlock],
["PagesProjectsChangeStructureButton", LazyPagesProjectsChangeStructureButton],
["PagesProjectsContentListPage", LazyPagesProjectsContentListPage],
["PagesProjectsContentPage", LazyPagesProjectsContentPage],
["PagesProjectsEditorContentPage", LazyPagesProjectsEditorContentPage],
["PagesProjectsFloatingRateCard", LazyPagesProjectsFloatingRateCard],
["PagesProjectsNewProjectContent", LazyPagesProjectsNewProjectContent],
["PagesProjectsProject", LazyPagesProjectsProject],
["PagesProjectsProjectAdminPanel", LazyPagesProjectsProjectAdminPanel],
["PagesProjectsProjectChapter", LazyPagesProjectsProjectChapter],
["PagesProjectsProjectContent", LazyPagesProjectsProjectContent],
["PagesProjectsProjectMainDownload", LazyPagesProjectsProjectMainDownload],
["PagesProjectsProjectMainTop", LazyPagesProjectsProjectMainTop],
["PagesProjectsProjectPageSide", LazyPagesProjectsProjectPageSide],
["PagesProjectsPromocodeInput", LazyPagesProjectsPromocodeInput],
["PagesProjectsSimilarProjects", LazyPagesProjectsSimilarProjects],
["PagesProjectsTItlePage", LazyPagesProjectsTItlePage],
["PagesProjectsActionBlockTimer", LazyPagesProjectsActionBlockTimer],
["PagesProjectsActionBlockCopyActionBlock", LazyPagesProjectsActionBlockCopyActionBlock],
["PagesProjectsActionBlockFixedActionBlock", LazyPagesProjectsActionBlockFixedActionBlock],
["PagesProjectsActionBlockPaymentActionBlock", LazyPagesProjectsActionBlockPaymentActionBlock],
["PagesProjectsActionBlockPaymentPendingBlock", LazyPagesProjectsActionBlockPaymentPendingBlock],
["PagesProjectsActionBlockPromocodeModalButton", LazyPagesProjectsActionBlockPromocodeModalButton],
["PagesProjectsDownloadButtonsDownloadDocument", LazyPagesProjectsDownloadButtonsDownloadDocument],
["PagesProjectsDownloadButtonsDownloadPresentation", LazyPagesProjectsDownloadButtonsDownloadPresentation],
["PagesProjectsEditorContentEditor", LazyPagesProjectsEditorContentEditor],
["PagesProjectsEditorRu", LazyPagesProjectsEditorRu],
["PagesProjectsPaymentCopyButton", LazyPagesProjectsPaymentCopyButton],
["PagesProjectsPaymentNewPaymentButton", LazyPagesProjectsPaymentNewPaymentButton],
["PagesProjectsPaymentButton", LazyPagesProjectsPaymentButton],
["PagesProjectsPaymentDropdownButton", LazyPagesProjectsPaymentDropdownButton],
["PagesProjectsPaymentErrorModal", LazyPagesProjectsPaymentErrorModal],
["PromoFixedRefundBanner", LazyPromoFixedRefundBanner],
["PromoRefundBanner", LazyPromoRefundBanner],
["PromoRefundDetailsPopup", LazyPromoRefundDetailsPopup],
["PromoBlackFridayBadge", LazyPromoBlackFridayBadge],
["PromoBlackFridayBanner", LazyPromoBlackFridayBanner],
["PromoBlackFridayTimer", LazyPromoBlackFridayTimer],
["RatingRateModal", LazyRatingRateModal],
["RatingReviewRating", LazyRatingReviewRating],
["RatingSorryModal", LazyRatingSorryModal],
["RatingStarRatingIconStar", LazyRatingStarRatingIconStar],
["RatingStarRatingOtzovikModal", LazyRatingStarRatingOtzovikModal],
["RatingStarRating", LazyRatingStarRating],
["TopicsSubjectTopics", LazyTopicsSubjectTopics],
["TopicsVTopics", LazyTopicsVTopics],
["UserAccountModal", LazyUserAccountModal],
["UserDeleteRequest", LazyUserDeleteRequest],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
